import React, { useEffect, useState } from 'react';
import {Table, Container, Button} from 'react-bootstrap';
import classes from '../../WebsiteManagement/websiteManagement.module.css';
import { DeleteBlog, GetBlog} from '../../../entities/action/action';

const ActiveBlogCard = (props)=>{
    const [dataSet,updateDataSet] = useState([]);
    useEffect(()=>{
        (async()=>{
            let arr = await GetBlog();
            if(arr?.success){
                updateDataSet(arr?.blogs);
            }
        })()
    },[])

    const handleDelete = async(id)=>{
        const res = await DeleteBlog(id);
        if(res?.success){
            alert("Successfully Deleted");
           window.location.reload()
        }
    }
    return(
        <Container fluid style={{padding:'0'}}>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Image</th>
                        <th>Title</th>
                        <th>Category</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        dataSet.length>0?dataSet.map((data,key)=>
                            <tr key={key}>
                                <td>{key+1}</td>
                                <td><img src={data.imageUrl} style={{width:'50px'}} alt="active coupon"/></td>
                                <td>{data.title}</td>
                                <td>{data.blogCategory}</td>
                                <td className={classes.CenterRow}>
                                    <Button style={{margin:'auto 1%'}} variant="danger" onClick={()=>handleDelete(data.id)}>Delete</Button>
                                </td>
                            </tr>
                        ):null
                    }
                </tbody>
            </Table>
        </Container>
    )
}
export default ActiveBlogCard;